<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/structures"></back-button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h4 v-if="structure != null">
            <u>Δομή : {{ structure.Description }}</u>
          </h4>
        </div>
      </div>
    </div>

    <div
      class="row"
      style="padding-top: 20px; padding-left: 20px"
      v-if="structure != null"
    >
      <form class="forms-style">
        <div class="row">
          <div class="col-md-6 col-md-offset-3">
            <div class="panel-heading">Γενικά στοιχεία</div>
            <div class="panel panel-primary">
              <div class="panel-body">
                <div class="form-group">
                  <label for="id" class="col-sm-3 control-label"
                    >Περιγραφή</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="Description"
                    v-model="structure.Description"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="IsActive" class="col-sm-3 control-label"
                    >Ενεργή</label
                  >
                  <input
                    type="checkbox"
                    id="IsActive"
                    v-model="structure.IsActive"
                    disabled
                  />
                </div>

                <div class="form-group">
                  <label for="ContactPerson" class="col-sm-3 control-label"
                    >Αρμόδιος</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="ContactPerson"
                    v-model="structure.ContactPerson"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="City" class="col-sm-3 control-label">Πόλη</label>
                  <input
                    type="text"
                    class="form-field"
                    id="City"
                    v-model="structure.City"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="Streetname" class="col-sm-3 control-label"
                    >Οδός</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="Streetname"
                    v-model="structure.StreetName"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="StreetNum" class="col-sm-3 control-label"
                    >Αριθμός</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="StreetNum"
                    v-model="structure.StreetNum"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="ZipCode" class="col-sm-3 control-label"
                    >Ταχ.Κώδικας</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="ZipCode"
                    v-model="structure.ZipCode"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="PhoneNumber" class="col-sm-3 control-label"
                    >Τηλέφωνο</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="PhoneNumber"
                    v-model="structure.PhoneNumber"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="FaxNumber" class="col-sm-3 control-label"
                    >Fax</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="FaxNumber"
                    v-model="structure.FaxNumber"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="Email" class="col-sm-3 control-label"
                    >Email</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="Email"
                    v-model="structure.Email"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="Municipality" class="col-sm-3 control-label"
                    >Δήμος</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="Municipality"
                    v-model="structure.MunicipalityDto.Description"
                    v-if="structure.MunicipalityId != null"
                    readonly
                  />

                  <!-- <div class="col-sm-9" v-if="structure.MunicipalityId != null">
                   <input type="text" class="form-field" id="Municipality" v-model="structure.MunicipalityDto.Description" readonly />
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import mainService from "../../services/mainService";

import BackButton from "../../components/shared/backButton";

export default {
  props: ["sId"],
  components: {
    BackButton,
  },
  data() {
    return {
      structure: null,
    };
  },
  computed: {
    organizationId() {
      return this.$store.getters.getSelectedOrganizationId;
    },
  },
  methods: {},

  async mounted() {
    const res = await mainService.get(
      `/structures/GetStructureById?id=${this.sId}&organizationId=${this.organizationId}`
    );
    this.structure = res.data;
  },
};
</script>
<style lang="scss" scoped>
.forms-style label {
  width: 120px;
}
input[type="checkbox"] {
  margin: 1px 0 0 5px;
  width: 40px;
  height: 40px;
}
</style>